interface StarburstProps {
	color: string;
	width: string;
	style?: React.CSSProperties;
}

export default function StarburstLines({
	color,
	style,
	width,
}: StarburstProps) {
	return (
		<svg
			width={width}
			viewBox="0 0 69 69"
			fill="none"
			style={style}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M34.2 36.2428L34.2 68.2725H35.2L35.2 36.2987L47.4344 65.835L48.3583 65.4523L36.1148 35.894L58.7349 58.5141L59.442 57.807L36.8311 35.1961L66.3673 47.4304L66.75 46.5065L37.2144 34.2725H68.2V33.2725H37.2011L65.835 21.4119L65.4524 20.488L36.8163 32.3495L58.7349 10.4308L58.0278 9.72374L36.103 31.6485L47.9666 3.00725L47.0428 2.62457L35.2 31.2155V0.272461H34.2V31.2713L22.3358 2.62854L21.4119 3.01122L33.267 31.632L11.3588 9.72374L10.6516 10.4308L32.5691 32.3483L3.92618 20.484L3.54349 21.4079L32.187 33.2725H0.200012V34.2725H32.1738L2.62855 46.5105L3.01124 47.4344L32.5543 35.1972L9.94454 57.807L10.6516 58.5141L33.2553 35.9105L21.0203 65.4484L21.9442 65.8311L34.2 36.2428Z"
				fill={color}
			/>
		</svg>
	);
}
